module.exports = ".link{\r\n    Font-Family:Arial,\"Open Sans\";\r\n\r\n}"